import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Input, Separator, Text, Textarea} from '@/src/ui';

import css from '../styles/ResultContactUsFormLayout.module.css';

const getValidationSchema = (t, isNotRequired) => {
  if (isNotRequired) {
    return Yup.object().shape({
      email: Yup.string().email(t('emailStep.email_is_invalid')),
    });
  }

  return Yup.object().shape({
    email: Yup.string()
      .email(t('emailStep.email_is_invalid'))
      .required(t('emailStep.email_is_required')),
    message: Yup.string().required(t('emailStep.email_is_required')),
  });
};

const ResultContactUsFormLayout = ({
  email,
  onSubmit,
  onCancel,
  isHideEmail,
  isNotRequired,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.mainWrapper}>
      <Formik
        initialValues={{
          email: email || '',
          message: '',
        }}
        validationSchema={getValidationSchema(t, isNotRequired)}
        onSubmit={onSubmit}
      >
        <Form className={css.form}>
          <div className={css.title}>
            <Text
              fontSize={Text.FONT_SIZE.SIZE_32}
              fontWeight={Text.FONT_WEIGHT.BOLD}
            >
              <TextLocal id={'header.leave-your-message'} />
            </Text>
          </div>

          <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />

          <div className={css.container}>
            {!isHideEmail && (
              // @ts-ignore
              <Input
                placeholder={t('wiki-how.enter-email')}
                name={'email'}
                width={Input.WIDTH.WIDTH_FULL}
              />
            )}
            {/*@ts-ignore*/}
            <Textarea
              name={'message'}
              minRows={5}
              placeholder={t('header.leave-your-comment')}
            />
          </div>
          <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
          <div className={css.buttonsWrapper}>
            <div className={css.buttons}>
              <div onClick={onCancel}>
                <Text fontSize={Text.FONT_SIZE.SIZE_16} color={Text.COLOR.GREY}>
                  <TextLocal id={'general.cancel'} />
                </Text>
              </div>
              <Button type={Button.TYPES.SUBMIT} height={Button.HEIGHT.SMALL}>
                <TextLocal id={'general.send'} />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

ResultContactUsFormLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  email: PropTypes.string,
  isHideEmail: PropTypes.bool,
  isNotRequired: PropTypes.bool,
};

export default ResultContactUsFormLayout;
